import { graphql, HttpResponse } from 'msw'
import { type EnrollmentHYCSFinancesData, type EnrollmentHYCSFinancesSubmitOutput } from '../../../../models'

export const getEnrollmentHYCSFinancesDataMock: EnrollmentHYCSFinancesData = {
  __typename: 'SubmitEnrollmentSuccess',
  path: '/enrollment/hycs/finances',
  enrollmentData: {
    applicationId: '305802305',
  },
}

export const submitEnrollmentHYCSFinancesDataMock: EnrollmentHYCSFinancesSubmitOutput = {
  __typename: 'SubmitEnrollmentSuccess',
  path: '/enrollment/hycs/verify-email',
}

export const mockGetEnrollmentHYCSFinancesData = graphql.mutation('getEnrollmentHYCSFinancesData', () => {
  return HttpResponse.json({ data: { submitEnrollment: getEnrollmentHYCSFinancesDataMock } })
})

export const mockSubmitEnrollmentHYCSFinancesData = graphql.mutation('submitEnrollmentHYCSFinancesData', () => {
  return HttpResponse.json({ data: { submitEnrollment: submitEnrollmentHYCSFinancesDataMock } })
})

export const mockEnrollmentHYCSFinances = [mockGetEnrollmentHYCSFinancesData, mockSubmitEnrollmentHYCSFinancesData]
